export { DSCollectionBox, DSCollectionBoxWithSchema } from './CollectionBox.js';
